export default __webpack_public_path__ + "static/media/Walnut-Cheesecake.6edcf09b.jpg";